import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

import "react-grid-layout/css/styles.css";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element missing in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
